import { Injectable, inject } from '@angular/core';
import { IAdditionalSheetSettings, isNotEmpty } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';
import { CpDatasourceService } from './cp-datasource.service';
import { CpModelService } from './cp-model.service';
import { CpReportService } from './cp-report.service';

@Injectable({
    providedIn: 'root',
})
export class CpAdditionalSheetsService {
    private readonly modelService = inject(CpModelService);
    private readonly datasourceService = inject(CpDatasourceService);
    private readonly reportService = inject(CpReportService);

    initialize = (additionalSheets: IAdditionalSheetSettings[]) => {
        const referenceExamination = this.reportService.referenceExamination;
        if (!referenceExamination || referenceExamination.getPropertyValue('IsReported')) {
            return;
        }
        additionalSheets.forEach(this.addAdditionaSheet);
    };

    private addAdditionaSheet = (additionalCard: IAdditionalSheetSettings) => {
        const targetBinding = new DataBinding(additionalCard.target);
        const mappingList = this.datasourceService.getById(additionalCard.mappingList);
        const fkTarget = additionalCard.foreignKeys.find((fk) => fk.binding === additionalCard.target);
        if (!fkTarget || !mappingList) return;
        const fkToFilter = additionalCard.foreignKeys
            .filter((fk) => fk.key !== fkTarget?.key)
            .map((fk) => ({ key: fk.key, values: this.getForeignKeyIds(fk.binding) }));
        const ids: string[] = mappingList
            .filter((item) =>
                fkToFilter.every((fk) => fk.values.includes(item.getPropertyPrimitiveValue(fk.key) as string)),
            )
            .map((item) => item.getPropertyPrimitiveValue(fkTarget.key) as string)
            .filter(isNotEmpty);
        const entities = ids
            .map((id) => this.modelService.makeEntityFromDataset(targetBinding.entity, undefined, id))
            .filter(isNotEmpty);
        this.modelService.setValue(targetBinding.entity, entities ?? [], {
            emitEvent: false,
        });
    };

    private getForeignKeyIds = (binding: string): string[] =>
        this.modelService
            .getEntities(new DataBinding(binding))
            ?.filter(isNotEmpty)
            .map((entity) => entity.getPropertyPrimitiveValue('Id')?.toString())
            .filter(isNotEmpty) ?? [];
}
